import { IcCapture } from '@assets/icons/40x40/mapMenu';
import { Icon } from '@chakra-ui/react';
import { useMapContext } from '@components/map/MapContext';
import { ButtonBar } from '@components/ui/buttonBar';
import { useAppStore } from '@hooks/redux.hooks';
import { selectSituationTime } from '@redux/situation/situation.selectors';
import { screenshotWithVideoFramesAndDownload } from '@utils/sensors/camera/screenshot.utils';
import { useIntl } from 'react-intl';

import { MapIdEnum } from '@/types/map.types';

function ScreenshotControl() {
  const { mapId } = useMapContext();
  const { formatMessage } = useIntl();
  const store = useAppStore();

  const downloadScreenshot = () => {
    const situationTime = selectSituationTime(store.getState(), mapId === MapIdEnum.REPLAY);
    void screenshotWithVideoFramesAndDownload(`${mapId}_map`, situationTime ?? 'UnknownDate');
  };

  return (
    <ButtonBar.Root
      aria-label={formatMessage({ id: 'cameras.cameraMenu.capture' })}
      notch
      notchPlacement="bottom-left"
      tooltipPlacement="left"
      onClick={downloadScreenshot}
    >
      <ButtonBar.Control>
        <Icon as={IcCapture} />
      </ButtonBar.Control>
    </ButtonBar.Root>
  );
}

export default ScreenshotControl;
